import { Customer } from '../types/customer';

export const formatCustomerName = (customer: Customer): string => {
  const firstName = customer.firstName || '';
  const lastName = customer.lastName || '';
  return `${firstName} ${lastName}`.trim() || 'N/A';
};

export const formatCustomerAddress = (customer: Customer): string => {
  const parts = [
    customer.streetOne,
    customer.streetTwo,
    customer.city,
    customer.state,
    customer.postalCode,
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(', ') : 'N/A';
};

export const formatCustomerPhone = (customer: Customer): string => {
  return customer.phone || 'N/A';
};
export const formatCustomerEmail = (customer: Customer): string => {
  return customer.email || 'N/A';
};
